import { Study, StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

import { StudyMetaInfo } from '../config';

export const getStudyIDsByType = (
  studies: (Study | StudyMetaInfo)[],
  type: StudyType,
): string[] =>
  studies
    .filter(
      (study) => ('Type' in study ? study.Type : study.studyType) === type,
    )
    .map((study) => study.ID);
